module.exports = __webpack_public_path__ + "img/screencapture-netflix-watch-81262750-2021-10-01-22_42_34.4b0e30d0.png";